import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * SlimFooterComponent — a one-line brand footer for internal, logged-in tools
 * (operator #2206, admin #2246).
 *
 * The full marketing `FooterComponent` (SERVICE / COMPANY / AREAS SERVED columns
 * + SEO strapline, all pointing at the public marketing site) does not belong on
 * an internal field tool: at 375px it was over half the scrollable page, and its
 * external links navigate a signed-in operator clean out of a live session onto
 * the marketing site. This keeps the brand line without any marketing nav aimed
 * at a logged-in user.
 */
@Component({
  selector: 'abx-slim-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <footer class="abx-slim-footer">
      <span class="abx-slim-footer__brand">© 2026 AppliedBioX</span>
    </footer>
  `,
  styles: [
    `
      .abx-slim-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.75rem 1rem;
        border-top: 1px solid var(--color-border);
        background: var(--color-bg);
      }
      .abx-slim-footer__brand {
        font-family: var(--font-mono);
        font-size: 0.75rem;
        letter-spacing: 0.04em;
        color: var(--color-muted);
      }
    `,
  ],
})
export class SlimFooterComponent {}
